import React, { Component } from 'react';
import { graphql, withApollo, compose } from 'react-apollo';
import gql from 'graphql-tag';
import T from 'i18n-react';
import configureT from './configureT';
import LoaSigningForm from './LoaSigningForm';
import LoaSignConfirmation from './LoaSignConfirmation';
import SuccessInfo from './SuccessInfo';
import Spinner from './Spinner';
import logo from '../assets/img/airrefund.png';
import message from './Message';
import 'url-search-params-polyfill';

class LoaSigningContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loa: {},
      confirmation: false,
      successInfo: false,
      errorInfo: false,
      isMutationLoading: false
    }
    this.handleSign = this.handleSign.bind(this);
    this.handleSignConfirm = this.handleSignConfirm.bind(this);
  }

  toggleConfirmWindow=()=>{
    this.setState({confirmation: !this.state.confirmation})
  }

  handleSign = (loa) => {
    this.setState({loa: loa})
    this.toggleConfirmWindow();
  }
  handleSignConfirm = () => {
    this.setState({isMutationLoading: true, confirmation: false});

    this.props.signLoa({
      variables: {
        input: {
          token: urlParams.get('id'),
          loa: this.state.loa
        }
      }
    })
    .then(({ data }) => {
      console.log('got data', data);
      this.setState({successInfo: true, isMutationLoading: false})
    }).catch((error) => {
      console.dir(error)
      window.scrollTo(0,0)
      this.setState({errorInfo: true, isMutationLoading: false})
    });
  }

  render() {
    const { loading, loa } = this.props.unsignedLoa;

    if(!loading && !this.state.isMutationLoading){
      if(!loa || this.state.errorInfo){
        return message("Server error occured. Please try again later.");
      }
      const language = loa.claimsPassengerTicket.passengerTicket.passengerLanguage;
      configureT(language, 'loaSign')
      let confirmation;
      if(this.state.confirmation){
        confirmation = <LoaSignConfirmation
          toggleConfirmWindow={this.toggleConfirmWindow}
          handleSignConfirm={this.handleSignConfirm} />
      }

      if (this.state.successInfo){
        return <SuccessInfo
          title={T.translate("correctHeader")}
          text={T.translate("correctBody")} />
      } else {
        return(
          <div>
            {
              !loa.loaConsent ?
                <div className="loa-signing">
                  {confirmation}
                  <img src={logo} alt="logo"/>
                  <LoaSigningForm
                    Loa={loa}
                    handleSign={this.handleSign}
                  />
                </div>
                :
                message(T.translate("alreadySigned"), true)
            }
          </div>
        )
      }
    } else {
      return <Spinner />
    }
  }
}

const urlParams = new URLSearchParams(window.location.search)

const GetLoa = gql`
  query ($token: String!) {
    loa(token: $token) {
      id,
      loaConsent,
      tcConsent,
      visaConsent,
      visaCard,
      claimsPassengerTicket {
        passengerTicket {
          passengerLanguage
        }
        claim {
          id,
          affiliate {
            name
          }
        }
      }
      guardianFullName,
      loaDocumentUrl,
      adult,
      signedLoaDocumentUrl
    }
  }
`

const SignLoa = gql`
  mutation SignLoa($input: SignLoaMutationInput!) {
    signLoa(input: $input){
      loa{
        id
      }
    }
  }
`

LoaSigningContainer = compose(
  withApollo,
  graphql(GetLoa, {
    name: 'unsignedLoa',
    options: {
      variables : {
        token: urlParams.get('id')
      }
    }
  }),
  graphql(SignLoa, {name: 'signLoa'})
)(LoaSigningContainer);

const LoaSigning = props =>
  <LoaSigningContainer {...props}/>;

export default LoaSigning;



// WEBPACK FOOTER //
// ./src/components/LoaSigning.js